<div [class.p-4]="!dialogRef">
  <div style="display: flex; align-items: center; gap: 12px">
    <h4 mat-dialog-title style="margin: 0; flex: 1 1 auto">
      <span *ngIf="!fabbricato; else editHeader">
        Creazione Nuovo Fabbricato
      </span>
      <ng-template #editHeader>
        Modifica Fabbricato {{ fabbricato.nome }}
      </ng-template>
    </h4>
    <button
      *ngIf="fabbricato?.id"
      mat-stroked-button
      color="primary"
      [disabled]="isUpdating"
      (click)="aggiornaIndirizzoDaUltimoIncarico()"
      title="Aggiorna indirizzo da ultimo incarico"
    >
      Aggiorna indirizzo
    </button>
  </div>

  <form
    *ngIf="form; else loader"
    [formGroup]="form"
    class="mt-4 row"
    (keydown.enter)="edit()"
  >
    <mat-form-field>
      <mat-label>Nome</mat-label>
      <input matInput formControlName="nome" />
    </mat-form-field>

    <mat-form-field>
      <mat-label> Via / piazza </mat-label>
      <input matInput formControlName="via" />
    </mat-form-field>

    <mat-form-field>
      <mat-label> N. civico </mat-label>
      <input matInput formControlName="civico" />
    </mat-form-field>

    <mat-form-field>
      <mat-label> Comune </mat-label>
      <comune-picker formControlName="comune"></comune-picker>
    </mat-form-field>

    <mat-form-field>
      <mat-label> CAP </mat-label>
      <input matInput formControlName="cap" />
    </mat-form-field>
    <mat-form-field>
      <mat-label> Partita IVA </mat-label>
      <input matInput formControlName="partita_iva" />
    </mat-form-field>

    <mat-form-field>
      <mat-label> Codice fiscale </mat-label>
      <input matInput formControlName="codice_fiscale" />
    </mat-form-field>
    <mat-form-field>
      <mat-label> IBAN </mat-label>
      <input matInput formControlName="IBAN" />
    </mat-form-field>
    <mat-form-field>
      <mat-label> Amministratore </mat-label>
      <amministratore-picker formControlName="amministratore">
      </amministratore-picker>
    </mat-form-field>
    <mat-form-field>
      <mat-label> Estensione </mat-label>
      <input matInput formControlName="estensione" />
    </mat-form-field>
    <mat-form-field>
      <mat-label> Unita di misura estensione </mat-label>
      <mat-select formControlName="unita_misura_estensione_id">
        <mat-option value="1"> mc. </mat-option>
        <mat-option value="2"> mq. </mat-option>
        <mat-option value="3"> kg. </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="mat-form-field">
      <mat-slide-toggle formControlName="verificato_su_planimetrie">
        Verificato su planimetrie
      </mat-slide-toggle>
    </div>

    <div class="mat-form-field">
      <mat-slide-toggle formControlName="verificato_su_google_earth">
        Verificato su Google Earth
      </mat-slide-toggle>
    </div>

    <mat-form-field>
      <mat-label> N. piani fuori terra </mat-label>
      <input
        type="number"
        min="0"
        matInput
        formControlName="numero_piani_fuori_terra"
      />
    </mat-form-field>

    <mat-form-field>
      <mat-label> N. piani entro terra </mat-label>
      <input
        type="number"
        min="0"
        matInput
        formControlName="numero_piani_entro_terra"
      />
    </mat-form-field>

    <mat-form-field class="mb-4">
      <mat-label> Percentuale superficie piani interrati </mat-label>
      <input
        type="number"
        min="0"
        max="100"
        matInput
        formControlName="percentuale_superficie_piani_interrati"
      />
      <mat-hint>
        Porzione percentuale della superficie dei piani interrati rispetto a
        quelli fuori terra
      </mat-hint>
      <span matSuffix> % </span>
    </mat-form-field>

    <mat-form-field>
      <mat-label> Estensione garage e servizi a piano terra </mat-label>
      <input
        type="number"
        min="0"
        matInput
        formControlName="estensione_garage_servizi_piano_terra"
      />
    </mat-form-field>
    <mat-form-field>
      <mat-label> Uso civile e uffici </mat-label>
      <input
        type="number"
        min="0"
        max="100"
        matInput
        formControlName="percentuale_uso_civile_uffici"
      />
      <span matSuffix> % </span>
    </mat-form-field>

    <mat-form-field>
      <mat-label> Uso commerciale e ind. </mat-label>
      <input
        type="number"
        min="0"
        max="100"
        matInput
        formControlName="percentuale_uso_commerciale"
      />
      <span matSuffix> % </span>
    </mat-form-field>

    <mat-form-field>
      <mat-label> Tipologia costruttiva </mat-label>
      <tipologia-costruttiva-picker
        formControlName="tipologia_costruttiva"
      ></tipologia-costruttiva-picker>
    </mat-form-field>

    <mat-form-field>
      <mat-label> Anno costruzione </mat-label>
      <input
        type="number"
        min="1000"
        max="2100"
        matInput
        formControlName="anno_costruzione"
      />
    </mat-form-field>

    <mat-form-field>
      <mat-label> Anno ristrutturazione </mat-label>
      <input
        type="number"
        min="1000"
        max="2100"
        matInput
        formControlName="anno_ristrutturazione"
      />
    </mat-form-field>

    <mat-form-field>
      <mat-label> Classe fabbricato </mat-label>
      <classe-fabbricato-picker
        formControlName="classe_fabbricato"
      ></classe-fabbricato-picker>
    </mat-form-field>

    <mat-form-field>
      <mat-label> Stato manutenzione generale </mat-label>
      <stato-manutenzione-picker
        formControlName="stato_manutenzione_generale"
      ></stato-manutenzione-picker>
    </mat-form-field>

    <mat-form-field>
      <mat-label> Stato manutenzione impianto idrico/igenico </mat-label>
      <stato-manutenzione-picker
        formControlName="stato_manutenzione_impianto_idrico_igenico"
      >
      </stato-manutenzione-picker>
    </mat-form-field>

    <mat-form-field class="mb-4">
      <mat-label> Altri valori </mat-label>
      <input matInput formControlName="altri_valori" />
      <mat-hint>
        Valore di cancelli, recinzioni, dipendenze, vani tecnici in corpi
        staccati
      </mat-hint>
      <span matSuffix> € </span>
    </mat-form-field>

    <mat-form-field class="mb-4">
      <mat-label> Costo unitario </mat-label>
      <input matInput formControlName="costo_unitario" />
      <mat-hint>
        Costo unitario di ristrutturazione a nuovo nel caso di civili abitazioni
        e uffici
      </mat-hint>
      <span matSuffix> € </span>
    </mat-form-field>

    <mat-form-field>
      <mat-label> Degrado percentuale </mat-label>
      <input
        type="number"
        min="0"
        max="100"
        matInput
        formControlName="degrado_percentuale"
      />
      <span matSuffix> % </span>
    </mat-form-field>

    <div class="col-12">
      <somme-assicurate
        *ngIf="polizzaSommeAssicurate"
        class="preesistenza-somme-assicurate"
        [heading]="false"
        [polizza]="polizzaSommeAssicurate"
      ></somme-assicurate>

      <div class="preesistenza-title">Preesistenza</div>
      <div class="preesistenza fabbricato-preesistenza">
        <div formArrayName="preesistenza">
          <div *ngFor="let voce of preesistenzaFormArray.controls; let i = index" [formGroupName]="i">
            <div class="voce-row-preesistenza">
              <div [ngStyle]="{ width: i >= 3 && i <= 5 ? '90%' : null }">
                <mat-form-field appearance="outline">
                  <input matInput formControlName="nome" placeholder="Voce" />
                </mat-form-field>
              </div>

              <div *ngIf="!(preesistenzaFormArray.at(i)?.get('isDegrado')?.value) && i < 4">
                <mat-form-field appearance="outline">
                  <mat-select formControlName="unitaMisura" placeholder="Unità" (selectionChange)="syncPreesistenzaUnitaMisura($event.value)">
                    <mat-option value="mc.">mc.</mat-option>
                    <mat-option value="mq.">mq.</mat-option>
                    <mat-option value="kg.">kg.</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div *ngIf="!(preesistenzaFormArray.at(i)?.get('isDegrado')?.value) && i < 4">
                <mat-form-field appearance="outline">
                  <input matInput type="text" formControlName="quantita" placeholder="Quantità" itNumberFormat />
                </mat-form-field>
              </div>

              <div [ngStyle]="{ width: preesistenzaFormArray.at(i)?.get('isDegrado')?.value ? '30%' : '10%' }">
                <mat-form-field appearance="outline">
                  <input matInput type="text" formControlName="prezzo" [placeholder]="preesistenzaFormArray.at(i)?.get('isDegrado')?.value ? 'Degrado %' : 'Prezzo'" itNumberFormat />
                </mat-form-field>
              </div>

              <div>
                <mat-form-field appearance="outline">
                  <input matInput type="text" formControlName="totale" placeholder="Totale" itNumberFormat />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="preesistenza-derived-metrics">
        <div>
          <span class="label">Totale mc</span>
          <span class="value" *ngIf="totaleMcDisplay != null; else noTotaleMc">
            {{ totaleMcDisplay | number: "1.0-0" }} mc
          </span>
        </div>
        <div>
          <span class="label">Valore medio</span>
          <span
            class="value"
            *ngIf="valoreMedioDisplay != null; else noValoreMedio"
          >
            {{ valoreMedioDisplay | number: "1.2-2" }} €
          </span>
        </div>
      </div>
    </div>

    <ng-template #noTotaleMc>
      <span class="value">-</span>
    </ng-template>
    <ng-template #noValoreMedio>
      <span class="value">-</span>
    </ng-template>

    <mat-form-field>
      <mat-label>Note</mat-label>
      <textarea
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="10"
        matInput
        formControlName="note"
      ></textarea>
    </mat-form-field>

    <mat-card class="my-2">
      <mat-card-header>
        <mat-card-title> Ubicazione e descrizione del rischio </mat-card-title>
      </mat-card-header>

      <mat-card-content>
        {{ fabbricato?.ubicazione_descrizione_rischio }}
      </mat-card-content>
    </mat-card>
  </form>
  <button mat-raised-button (click)="edit()" color="primary">Salva</button>
  <ng-template #loader>
    <mat-spinner></mat-spinner>
  </ng-template>
</div>
